import { X } from 'lucide-react';

type RemovableTagProps = {
  label: string;
  onRemove?: () => void;
  onClick?: () => void;
  title?: string;
  className?: string;
  compact?: boolean;
  compactWidth?: 'fixed' | 'half' | 'full';
};

export default function RemovableTag({ label, onRemove, onClick, title, className = '', compact = false, compactWidth = 'fixed' }: RemovableTagProps) {
  const compactWidthClass = compactWidth === 'full'
    ? 'w-full'
    : compactWidth === 'half'
      ? 'w-[calc(50%-4px)]'
      : 'w-[78.26px]';

  return (
    <span
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick ? (event) => {
        event.stopPropagation();
        onClick();
      } : undefined}
      onKeyDown={onClick ? (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          onClick();
        }
      } : undefined}
      className={`inline-flex min-w-0 max-w-full items-center whitespace-nowrap rounded-lg border border-[#2c4476] bg-[#19233c] leading-none text-[#93bbf6] transition-colors hover:border-[#3b5d9f] hover:bg-[#1f2d4d] ${compact ? `h-7 ${compactWidthClass} justify-center gap-x-[5px] px-[5px] pb-0 pt-0.5 text-[10px] font-medium uppercase` : 'gap-1.5 px-2.5 py-1.5 text-xs font-semibold'} ${onClick ? 'cursor-pointer' : ''} ${className}`}
      style={compact ? { fontFamily: '"Inter Variable", Arial, sans-serif' } : undefined}
      title={title ?? label}
    >
      <span className="min-w-0 truncate">{label}</span>
      {onRemove ? (
        <button
          type="button"
          aria-label={`Remove ${label}`}
          onClick={(event) => {
            event.stopPropagation();
            onRemove();
          }}
          className="inline-flex h-4 w-4 shrink-0 items-center justify-center rounded text-[#93bbf6]/75 transition-colors hover:bg-[#2c4476] hover:text-white focus:outline-none focus:ring-1 focus:ring-[#93bbf6]/60"
        >
          <X className={compact ? 'h-3.5 w-3.5' : 'h-3 w-3'} />
        </button>
      ) : null}
    </span>
  );
}
